import { AfterViewInit, Component, OnInit } from '@angular/core';
import { BrandViewModel } from '../../../Models/CheckInModel';
import { localStorageKeys } from '../../../Models/configurations';
import { CheckInDataService } from '../../../Services/check-in-data.service';
import { SecureStorageService } from './../../../Services/secure-storage.service';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';

@Component({
  selector: 'app-brand-image',
  templateUrl: './brand-image.component.html'
})
export class BrandImageComponent implements OnInit {
  brandCode: string;
  brandName: string;

  constructor(private readonly secureStorageService: SecureStorageService,
    private readonly globalSetting: GlobalSetting) {
  }

  ngOnInit(): void {
    if (typeof (this.secureStorageService.getKeyData(localStorageKeys.checkingModule)) !== 'undefined') {
      this.brandCode = this.secureStorageService.getKeyData(localStorageKeys.checkingModule).vehicleDetail.companyMake;
      this.brandName = this.secureStorageService.getKeyData(localStorageKeys.checkingModule).vehicleDetail.companyMake;
    }
    this.globalSetting.checkinData.subscribe((res) => {
      if (res?.vehicleDetail) {
        this.brandCode = res.vehicleDetail.companyMake;
        this.brandName = res.vehicleDetail.companyMake;
      }
    });
  }
}
